import { Route } from "react-router-dom"
import { lazy } from "react"
import { LazyPage } from "@/router/lazy-page"

// Layouts
import MarketingLayout from "@/layouts/marketing-layout"
import AuthLayout from "@/layouts/auth-layout"
import { RootHomePage, GuestGuard } from "@/router/guards"

// Pages
const Solutions = lazy(() => import("@/pages/marketing/solutions"))
const Contact = lazy(() => import("@/pages/marketing/contact"))
const Development = lazy(() => import("@/pages/marketing/development"))

// Auth Pages
const SignIn = lazy(() => import("@/pages/auth/signin"))
const SignUp = lazy(() => import("@/pages/auth/signup"))
const LinkBusinessOwner = lazy(() => import("@/pages/auth/link-business-owner"))
const ResetPassword = lazy(() => import("@/pages/auth/reset-password"))

// Legal
const TermsOfService = lazy(() => import("@/pages/legal/terms"))
const PrivacyPolicy = lazy(() => import("@/pages/legal/privacy"))

export const PublicRoutes = () => (
    <>
        {/* Root route - shows marketing for guests, redirects to dashboard for auth users */}
        <Route element={<MarketingLayout />}>
            <Route path="/" element={<RootHomePage />} />
        </Route>

        {/* Guest routes (only for unauthenticated users) */}
        <Route element={<GuestGuard />}>
            <Route element={<AuthLayout />}>
                <Route path="/sign-in" element={<LazyPage fallback="bootstrap"><SignIn /></LazyPage>} />
                <Route path="/sign-up" element={<LazyPage fallback="bootstrap"><SignUp /></LazyPage>} />
                <Route path="/sign-up/link-business-owner" element={<LazyPage fallback="bootstrap"><LinkBusinessOwner /></LazyPage>} />
                <Route path="/forgot-password" element={<LazyPage fallback="bootstrap"><ResetPassword /></LazyPage>} />
                <Route path="/verify-email" element={<LazyPage fallback="bootstrap"><ResetPassword /></LazyPage>} />
            </Route>
        </Route>

        {/* Public marketing pages */}
        <Route element={<MarketingLayout />}>
            <Route path="/solutions" element={<LazyPage fallback="bootstrap"><Solutions /></LazyPage>} />
            <Route path="/contact" element={<LazyPage fallback="bootstrap"><Contact /></LazyPage>} />
            <Route path="/developers" element={<LazyPage fallback="bootstrap"><Development /></LazyPage>} />
            <Route path="/terms" element={<LazyPage fallback="bootstrap"><TermsOfService /></LazyPage>} />
            <Route path="/privacy" element={<LazyPage fallback="bootstrap"><PrivacyPolicy /></LazyPage>} />
        </Route>
    </>
)
